// Mobile Product Popup
document.addEventListener("DOMContentLoaded", function () {
  // Check if mobile
  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  // Create popup HTML structure
  function createPopupHTML(productData) {
    return `
      <div class="popup-overlay">
        <div class="popup-content main-prd-card" data-product-handle="${productData.productHandle}">
          
          <!-- Close Button -->
          <a href="#" class="popup-close">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
              <path d="M12.6201 12.62L23.3799 23.3798" stroke="currentColor" stroke-miterlimit="10"></path>
              <path d="M12.6201 23.3798L23.3799 12.62" stroke="currentColor" stroke-miterlimit="10"></path>
            </svg>
          </a>
          
          
          <!-- Media Container -->
          <div class="popup-media">
            <button type="button" class="extras-btn open-mobile-extras-drawer">
              Extras 
              <span class="extras-icon">+</span>
            </button>
            
            <!-- Image Slider -->
            <div class="popup-image-slider" data-slider="true" style="--current-image-index: 0;">
              ${productData.images
                .map(
                  (image, index) => `
                <div class="popup-slide-container">
                  <img src="${image.src}" alt="${image.alt}" loading="eager" class="popup-slide-img" onerror="this.src='https://via.placeholder.com/400x300/cccccc/666666?text=Image+${index + 1}'">
                </div>
              `
                )
                .join("")}
            </div>
            
            <!-- Slider Navigation -->
            <div class="popup-slider-navigation">
              <button class="popup-slider-prev" data-prev="true">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M7.5 9L4.5 6L7.5 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
              </button>
              <div class="popup-slider-counter">
                <span class="popup-current-index">1</span>
                <span class="popup-separator">/</span>
                <span class="popup-total-count">${
                  productData.images.length
                }</span>
              </div>
              <button class="popup-slider-next" data-next="true">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M4.5 3L7.5 6L4.5 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
              </button>
            </div>
          </div>
          
          <!-- Content Container -->
          <div class="popup-content-body">
            
            
            <!-- Product Details -->
            <div class="product-details">
              <div class="product-header">
                <div class="product-info">
                  <h3 class="product-title">${productData.title}</h3>
                  <div class="product-pricing">
                    <div class="price">${productData.price}</div>
                  </div>
                </div>
              </div>
              
              <!-- Product Swatches -->
              <div class="mpc-prd-swatches d-flex align-center">
                ${productData.swatches && productData.swatches.length > 0 
                  ? productData.swatches.map(swatch => `
                    <div class="spc-prd-swatch-block ${swatch.isActive ? 'spc-prd-swatch-block-ac' : ''}" 
                         data-material="${swatch.material}" 
                         data-current-material="${productData.oldCurrentMaterial || '14k-white-gold'}"
                         data-images='${JSON.stringify(swatch.images)}' 
                         style="${swatch.backgroundStyle}">
                      <span style="${swatch.backgroundStyle}"></span>
                    </div>
                  `).join('')
                  : `
                    <div class="spc-prd-swatch-block" data-material="14k-white-gold" data-current-material="${productData.oldCurrentMaterial || '14k-white-gold'}" data-images="[]" style="background: linear-gradient(41.85deg,#ccc -6.28%,#f1f1f1 16.39%,#f7f7f7 36.42%,#e2e2e2 55.22%,#c4c4c4 69.34%,#b3b3b3 81.42%);">
                      <span style="background: linear-gradient(41.85deg,#ccc -6.28%,#f1f1f1 16.39%,#f7f7f7 36.42%,#e2e2e2 55.22%,#c4c4c4 69.34%,#b3b3b3 81.42%)"></span>
                    </div>
                    <div class="spc-prd-swatch-block" data-material="14k-yellow-gold" data-current-material="${productData.oldCurrentMaterial || '14k-white-gold'}" data-images="[]" style="background: linear-gradient(43.31deg,#fbc926 -15.3%,#fffbcc 23.89%,#f8f0bb 33.68%,#e7d28e 48.37%,#cca246 69.6%,#c3922e 81.03%,#fbc926 121.84%,#fffbcc 141.43%)">
                      <span style="background: linear-gradient(43.31deg,#fbc926 -15.3%,#fffbcc 23.89%,#f8f0bb 33.68%,#e7d28e 48.37%,#cca246 69.6%,#c3922e 81.03%,#fbc926 121.84%,#fffbcc 141.43%)"></span>
                    </div>
                    <div class="spc-prd-swatch-block" data-material="14k-rose-gold" data-current-material="${productData.oldCurrentMaterial || '14k-white-gold'}" data-images="[]" style="background: linear-gradient(36.69deg,#fe7a69 2.63%,#fdd1cb 22.9%,#f5b9b1 41.39%,#f1988d 54.34%,#d67e73 66.99%,#b4655b 87.97%)">
                      <span style="background: linear-gradient(36.69deg,#fe7a69 2.63%,#fdd1cb 22.9%,#f5b9b1 41.39%,#f1988d 54.34%,#d67e73 66.99%,#b4655b 87.97%)"></span>
                    </div>
                  `
                }
              </div>

              <!-- Product Options -->
              <div class="product-options">
                <div class="options-grid">
                  ${productData.options
                    .map(
                      (option) => `
                    <button type="button" class="option-btn">
                      <div class="option-icon">${option.icon}</div>
                      <div class="option-name">${option.name}</div>
                    </button>
                  `
                    )
                    .join("")}
                </div>
              </div>
              
               <!-- Action Buttons -->
               <div class="action-buttons">
                 <a class="btn btn-outline more-info-btn" href="${
                   productData.url
                 }">More Info</a>
                <button class="btn btn-primary">
                  <span>Add to Cart</span>
                  <svg width="12" height="12" viewBox="0 0 17 18">
                    <path d="M5.5 15.8298L12 9.3298L5.5 2.8298" stroke="currentColor" stroke-width="2.5"></path>
                  </svg>
                </button>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      
      <!-- Mobile Extras Drawer -->
      <div id="mobile-extras-drawer" class="mobile-extras-drawer" role="dialog" aria-labelledby="mobile-extras-drawer-title" aria-hidden="true">
        <div class="mobile-extras-drawer__overlay" data-mobile-extras-close></div>
        <div class="mobile-extras-drawer__container">
          <div class="mobile-extras-drawer__header">
            <h2 id="mobile-extras-drawer-title" class="mobile-extras-drawer__title">Choose your upgrades</h2>
            <button class="mobile-extras-drawer__close" data-mobile-extras-close aria-label="Close drawer">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 16 16">
                <path d="M15.2 1.2L14.8.8c-.4-.4-1-.4-1.4 0L8 6.6 2.6.8c-.4-.4-1-.4-1.4 0L.8 1.2c-.4.4-.4 1 0 1.4L6.6 8 .8 13.4c-.4.4-.4 1 0 1.4l.4.4c.4.4 1 .4 1.4 0L8 9.4l5.4 5.8c.4.4 1 .4 1.4 0l.4-.4c.4-.4.4-1 0-1.4L9.4 8l5.8-5.4c.4-.4.4-1 0-1.4z"/>
              </svg>
            </button>
          </div>

          <div class="mobile-extras-drawer__content">
            <div class="mobile-extras-products-grid" id="mobile-extras-products">
              <!-- Add-on products will be loaded here -->
            </div>
          </div>

          <div class="mobile-extras-drawer__footer">
            <div class="mobile-extras-drawer__actions">
              <button type="button" class="mobile-extras-drawer__cancel" data-mobile-extras-close>Cancel</button>
              <button type="button" class="mobile-extras-drawer__select-upgrade" id="mobile-extras-select-upgrade">
                Select Upgrade
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // Extract product data from card
  function extractProductData(card) {
    const title =
      card.querySelector("h4.product-title")?.textContent?.trim() || "Product Title";
    const price =
      card.querySelector(".mpc-reg-price")?.textContent?.trim() || "$0";
    const url = card.querySelector(".product-link")?.getAttribute('data-url') || card.querySelector(".product-link")?.href || "#";

    // Extract images from slider
    const images = [];
    const imageElements = card.querySelectorAll(".ab-img");
    
    imageElements.forEach((img, index) => {
      if (img.src) {
        images.push({
          src: img.src,
          alt: img.alt || title,
        });
      }
    });

    // Extract swatches from card
    const swatches = [];
    const swatchElements = card.querySelectorAll('.spc-prd-swatch-block');
    
    swatchElements.forEach(swatch => {
      const material = swatch.getAttribute('data-material');
      const images = swatch.getAttribute('data-images');
      const isActive = swatch.classList.contains('spc-prd-swatch-block-ac');
      const backgroundStyle = swatch.getAttribute('style');
      
      if (material) {
        swatches.push({
          material: material,
          images: images ? JSON.parse(images) : [],
          isActive: isActive,
          backgroundStyle: backgroundStyle
        });
      }
    });

    

    // Extract current material from active swatch
    const currentMaterial = swatches.find(swatch => swatch.isActive)?.material || '14k-white-gold';
    
    // Extract old current material from data-current-material attribute
    const oldCurrentMaterial = card.querySelector('.spc-prd-swatch-block')?.getAttribute('data-current-material') || '14k-white-gold';
    
    // Extract product handle from URL
    const productHandle = url.replace('/products/', '');

    // Default product data
    const productData = {
      title: title,
      price: price,
      priceWithStone: "$2,800",
      url: url,
      productHandle: productHandle,
      currentMaterial: currentMaterial,
      oldCurrentMaterial: oldCurrentMaterial,
      images:
        images.length > 0
          ? images
          : [
              {
                src: "https://via.placeholder.com/400x400",
                alt: title,
              },
            ],
      swatches: swatches.length > 0 ? swatches : [
        {
          material: "14k-white-gold",
          images: [],
          isActive: false,
          backgroundStyle: "background: linear-gradient(41.85deg,#ccc -6.28%,#f1f1f1 16.39%,#f7f7f7 36.42%,#e2e2e2 55.22%,#c4c4c4 69.34%,#b3b3b3 81.42%);"
        },
        {
          material: "14k-yellow-gold",
          images: [],
          isActive: true,
          backgroundStyle: "background: linear-gradient(43.31deg,#fbc926 -15.3%,#fffbcc 23.89%,#f8f0bb 33.68%,#e7d28e 48.37%,#cca246 69.6%,#c3922e 81.03%,#fbc926 121.84%,#fffbcc 141.43%);"
        },
        {
          material: "14k-rose-gold",
          images: [],
          isActive: false,
          backgroundStyle: "background: linear-gradient(36.69deg,#fe7a69 2.63%,#fdd1cb 22.9%,#f5b9b1 41.39%,#f1988d 54.34%,#d67e73 66.99%,#b4655b 87.97%);"
        }
      ],
      options: [
        {
          name: "Oval",
          icon: `<svg class="block w-12 h-12" viewBox="0 0 48 48"><svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.5923 15.1672L23.9519 20.5252L20 14.0347L22.5923 15.1672H22.5923ZM30.5 20C30.5 27.732 25.799 34 20 34C14.201 34 9.5 27.732 9.5 20C9.5 12.268 14.201 6 20 6C25.799 6 30.5 12.268 30.5 20ZM23.9814 25.7606L25.6885 19.9999L23.9814 14.2396L20 11.9335L16.0186 14.2396L14.3115 19.9999L16.0186 25.7606L20 28.0668L23.9814 25.7606ZM15.2859 14.0709L13.0123 11.2233C11.5161 13.4522 10.5818 16.389 10.5139 19.6249H13.6414L15.2859 14.0709V14.0709ZM10.5139 20.3749C10.5818 23.6108 11.5161 26.5476 13.0122 28.7766L15.2859 25.9293L13.6414 20.3749H10.5139ZM24.7141 25.9293L26.9878 28.7766C28.4839 26.5476 29.4182 23.6108 29.4861 20.3749H26.3587L24.7141 25.9293ZM29.4861 19.6249C29.4182 16.3892 28.484 13.4526 26.988 11.2238L24.7141 14.0709L26.3586 19.6249H29.4861L29.4861 19.6249ZM24.0477 8.25654L20.6271 11.4296L24.2075 13.5038L26.5353 10.5891C25.8059 9.64027 24.9673 8.85267 24.0477 8.25654ZM20 7.00001C18.8118 7.00001 17.6783 7.3133 16.6289 7.86103L20 10.9882L23.3713 7.86122C22.3219 7.31337 21.1885 7.00001 20 7.00001ZM13.4651 10.5887L15.7926 13.5038L19.3731 11.4296L15.9526 8.25635C15.033 8.85236 14.1943 9.63996 13.4651 10.5887H13.4651ZM15.8887 31.7015L19.3665 28.5665L15.7926 26.4964L13.465 29.4111C14.1772 30.3378 14.9941 31.1104 15.8887 31.7015V31.7015ZM20 33C21.1884 33 22.3218 32.6867 23.3713 32.1389L19.9961 29.0082L16.5608 32.1047C17.6289 32.6751 18.7861 33 20 33H20ZM26.535 29.4111L24.2074 26.4964L20.6271 28.5702L24.0476 31.7435C24.9672 31.1475 25.8057 30.3599 26.535 29.4111Z" fill="black"></path></svg></svg>`,
        },
        {
          name: "Platinum",
          icon: `<svg class="block w-9 h-9" viewBox="0 0 36 36"><svg viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18.0498" cy="18" r="14.75" transform="rotate(90 18.0498 18)" stroke="url(#Platinum-1)" stroke-width="1.5"></circle><path d="M18.0498 4.75C25.3676 4.75 31.2998 10.6822 31.2998 18C31.2998 25.3178 25.3676 31.25 18.0498 31.25C10.732 31.25 4.7998 25.3178 4.7998 18C4.7998 10.6822 10.732 4.75 18.0498 4.75Z" stroke="url(#Platinum-2)" stroke-width="1.5"></path><path d="M13.3208 21.5H12.4078V14.163H15.3558C16.0671 14.163 16.6281 14.3757 17.0388 14.801C17.4495 15.2263 17.6548 15.7507 17.6548 16.374C17.6548 16.9973 17.4458 17.5217 17.0278 17.947C16.6171 18.3723 16.0598 18.585 15.3558 18.585H13.3208V21.5ZM15.2458 17.771C15.6785 17.771 16.0305 17.6427 16.3018 17.386C16.5731 17.122 16.7088 16.7847 16.7088 16.374C16.7088 15.9633 16.5731 15.6297 16.3018 15.373C16.0305 15.109 15.6785 14.977 15.2458 14.977H13.3208V17.771H15.2458ZM21.5919 21.5H20.6789V14.977H18.3579V14.163H23.9239V14.977H21.5919V21.5Z" fill="#808080"></path></svg></svg>`,
        },
        {
          name: "Pave",
          icon: `<svg class="block w-15 h-15" viewBox="0 0 48 48"><svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.13004 21.9634C4.24607 21.8964 4.38901 21.8964 4.50504 21.9634L5.4435 22.5052L5.0685 23.1548L4.31754 22.7212L3.20923 23.3611V24.6408L4.31754 25.2807L5.0685 24.8471L5.4435 25.4967L4.50504 26.0385C4.38901 26.1055 4.24606 26.1055 4.13004 26.0385L2.64673 25.1821C2.5307 25.1151 2.45923 24.9913 2.45923 24.8573V23.1446C2.45923 23.0106 2.5307 22.8868 2.64673 22.8198L4.13004 21.9634Z" fill="black"></path></svg></svg>`,
        },
      ],
      installment: "$191.67",
    };

    return productData;
  }

  // Initialize swatches - using global material swatch handler
  function initSwatches(popup) {
    // Debug: Check if swatches are present
    const swatches = popup.querySelectorAll('.spc-prd-swatch-block');
    
    // Add direct event listeners for popup swatches (bypass event delegation)
    swatches.forEach((swatch) => {
      swatch.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        
        // Call the global material swatch handler manually
        if (typeof window.handleMaterialSwatchClick === 'function') {
          window.handleMaterialSwatchClick(swatch, popup);
        } else {
          // Fallback: Update active state manually
          updateActiveSwatch(popup, swatch);
        }
      });
    });
  }
  
  // Update active swatch state
  function updateActiveSwatch(popup, clickedSwatch) {
    // Remove active class from all swatch blocks in this popup
    const swatchBlocks = popup.querySelectorAll('.spc-prd-swatch-block');
    swatchBlocks.forEach(block => {
      block.classList.remove('spc-prd-swatch-block-ac');
    });
    
    // Add active class to clicked swatch
    clickedSwatch.classList.add('spc-prd-swatch-block-ac');
  }

  // Initialize add to cart functionality
  function initAddToCart(popup) {
    const addToCartBtn = popup.querySelector('.btn-primary');
    
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Get the original product card from popup reference
        const originalCard = popup.originalCard;
        if (!originalCard) return;
        
        // Find the add to cart form in the original card
        const addToCartForm = originalCard.querySelector('form[data-type="add-to-cart-form"]');
        if (!addToCartForm) return;
        
        // Get the variant ID from the form
        const variantIdInput = addToCartForm.querySelector('input[name="id"]');
        if (!variantIdInput) return;
        
        const variantId = variantIdInput.value;
        if (!variantId) return;
        
        // Show loading state
        const originalText = this.querySelector('span')?.textContent || 'Add to Cart';
        this.disabled = true;
        this.style.opacity = '0.7';
        
        if (this.querySelector('span')) {
          this.querySelector('span').textContent = 'Adding...';
        }
        
        // Check if we have mobile extras addons
        const mainProductId = getCurrentProductId();
        const savedMobileExtras = getMobileExtrasForProduct(mainProductId);
        
        if (savedMobileExtras && savedMobileExtras.length > 0) {
          // Handle add-ons similar to addon-drawer.js
          handleMobileExtrasAddToCart(variantId, savedMobileExtras, mainProductId, this);
        } else {
          // Use the same logic as addon-drawer.js and product-form.js
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');
          
          // Add unique identifiers to prevent quantity merging (same as product-form.js)
          const uniqueId = Date.now().toString() + Math.random().toString(36).substr(2, 9);
          const sessionId = getSessionId();
          const cartTimestamp = Date.now().toString();
          
          // Add unique properties to form data
          formData.append('properties[_unique_id]', uniqueId);
          formData.append('properties[_session_id]', sessionId);
          formData.append('properties[_cart_timestamp]', cartTimestamp);
          formData.append('properties[_is_standalone_product]', 'true');
          
          // Add sections for cart drawer and cart icon bubble
          formData.append('sections', 'cart-drawer,cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
          
          // Use FormData with fetch (same as product-form.js)
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          };
          
          fetch('/cart/add.js', config)
          .then(response => response.json())
          .then(data => {
            // Reset button state
            this.disabled = false;
            this.style.opacity = '1';
            
            if (this.querySelector('span')) {
              this.querySelector('span').textContent = originalText;
            }
            
            if (data.status) {
              // Handle error
              alert('Error adding to cart: ' + data.description);
            } else {
              // Success - update cart drawer and cart icon bubble (same as addon-drawer.js)
              if (data.sections) {
                updateCartDrawerWithSections(data.sections);
              } else {
                // Fallback: trigger cart update event
                document.dispatchEvent(new CustomEvent('cart:updated'));
                document.dispatchEvent(new CustomEvent('cart:refresh'));
              }
              
              // Publish cart update event (same as addon-drawer.js)
              if (window.PUB_SUB_EVENTS && window.publish) {
                window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                  source: 'mobile-popup',
                  productVariantId: variantId,
                  cartData: data,
                });
              }
              
              // Open cart drawer to show all items (same as addon-drawer.js)
              setTimeout(() => {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  // Ensure is-empty class is removed before opening
                  cartDrawer.classList.remove('is-empty');
                  
                  if (typeof cartDrawer.open === 'function') {
                    cartDrawer.open();
                  } else {
                    // Fallback: try to trigger the cart drawer by clicking the cart icon
                    const cartIcon = document.querySelector('#cart-icon-bubble');
                    if (cartIcon) {
                      cartIcon.click();
                    }
                  }
                }
              }, 500);
              
              // Close popup after successful add to cart
              setTimeout(() => {
                closePopup();
              }, 1000);
            }
          })
          .catch(error => {
            // Reset button state
            this.disabled = false;
            this.style.opacity = '1';
            
            if (this.querySelector('span')) {
              this.querySelector('span').textContent = originalText;
            }
            
            alert('Error adding to cart. Please try again.');
          });
        }
      });
    }
  }

  // Initialize more info button
  function initMoreInfoButton(popup) {
    const moreInfoBtn = popup.querySelector('.more-info-btn');
    
    if (moreInfoBtn) {
      moreInfoBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Get the URL from the button's href attribute
        const url = this.getAttribute('href');
        
        if (url && url !== '#') {
          // Redirect to the product page
          window.location.href = url;
        }
      });
    }
  }

  // Initialize mobile extras drawer
  function initMobileExtrasDrawer(popup) {
    const extrasBtn = popup.querySelector('.open-mobile-extras-drawer');
    const drawer = document.getElementById('mobile-extras-drawer');
    
    if (!extrasBtn || !drawer) return;
    
    // Open drawer
    extrasBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openMobileExtrasDrawer();
    });
    
    // Close drawer
    const closeButtons = drawer.querySelectorAll('[data-mobile-extras-close]');
    closeButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        closeMobileExtrasDrawer();
      });
    });
    
    // Close on overlay click
    const overlay = drawer.querySelector('.mobile-extras-drawer__overlay');
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
          closeMobileExtrasDrawer();
        }
      });
    }
    
    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeMobileExtrasDrawer();
      }
    });
    
    // Add/Remove addon items
    drawer.addEventListener('click', function(e) {
      if (e.target.matches('[data-mobile-extras-toggle-button]') || e.target.closest('[data-mobile-extras-toggle-button]')) {
        const button = e.target.matches('[data-mobile-extras-toggle-button]') ? e.target : e.target.closest('[data-mobile-extras-toggle-button]');
        toggleMobileExtrasAddon(button);
      }
    });
    
    // Select upgrade button
    const selectButton = drawer.querySelector('#mobile-extras-select-upgrade');
    if (selectButton) {
      selectButton.addEventListener('click', function() {
        selectMobileExtrasUpgrades();
      });
    }
  }

  // Mobile extras drawer state
  let mobileExtrasSelectedAddons = new Map();
  let currentMobileProductId = null;

  // Open mobile extras drawer
  function openMobileExtrasDrawer() {
    const drawer = document.getElementById('mobile-extras-drawer');
    if (!drawer) return;
    
    // Check if drawer is already open BEFORE adding the class
    const isAlreadyOpen = drawer.classList.contains('is-open');
    
    // If already open, just bring to front (no reset)
    if (isAlreadyOpen) {
      return;
    }
    
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    // Get current product ID
    const newProductId = getCurrentProductId();
    
    // Check if this is a different product than before
    const isDifferentProduct = currentMobileProductId !== null && currentMobileProductId !== newProductId;
    
    if (isDifferentProduct || mobileExtrasSelectedAddons.size === 0) {
      // Different product or no selections, reset and load fresh
      mobileExtrasSelectedAddons.clear();
      currentMobileProductId = newProductId;
      loadMobileExtrasProductsFromCollection();
    } else {
      // Same product with existing selections, load products and restore UI
      loadMobileExtrasProductsFromCollection();
    }
  }

  // Close mobile extras drawer
  function closeMobileExtrasDrawer() {
    const drawer = document.getElementById('mobile-extras-drawer');
    if (!drawer) return;
    
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Load add-on products from Band collection via GraphQL
  function loadMobileExtrasProductsFromCollection() {
    const productsContainer = document.getElementById('mobile-extras-products');
    if (!productsContainer) return;
    
    // Show loading state
    productsContainer.innerHTML = '<div class="mobile-extras-loading">Loading add-ons...</div>';
    
    // GraphQL query to get products from Band collection
    const collectionId = 'gid://shopify/Collection/477237149719';
    const query = `
      query getCollectionProducts($id: ID!, $first: Int!) {
        collection(id: $id) {
          products(first: $first) {
            edges {
              node {
                id
                title
                images(first: 1) {
                  edges {
                    node {
                      url
                    }
                  }
                }
                variants(first: 1) {
                  edges {
                    node {
                      id
                      price {
                        amount
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
    
    const variables = {
      id: collectionId,
      first: 20
    };
    
    fetch('/api/2025-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.Shopify?.storefrontAccessToken || ''
      },
      body: JSON.stringify({
        query: query,
        variables: variables
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.data && data.data.collection && data.data.collection.products.edges.length > 0) {
        productsContainer.innerHTML = '';
        
        data.data.collection.products.edges.forEach(edge => {
          const product = edge.node;
          const productData = {
            id: product.id.split('/').pop(), // Extract numeric ID from GID
            title: product.title,
            price: product.variants.edges[0] ? Math.round(parseFloat(product.variants.edges[0].node.price.amount) * 100) : 0,
            image: product.images.edges[0] ? product.images.edges[0].node.url : '',
            variantId: product.variants.edges[0] ? product.variants.edges[0].node.id.split('/').pop() : ''
          };
          
          const productCard = createMobileExtrasOptionCard(productData);
          productsContainer.appendChild(productCard);
        });
        
        // Update button state after loading products
        updateMobileExtrasSelectButton();
        
        // If we have existing selections, restore the UI
        if (mobileExtrasSelectedAddons.size > 0) {
          updateMobileExtrasUIFromStorage();
        }
      } else {
        // No products found, show empty state
        productsContainer.innerHTML = '<div class="mobile-extras-empty">No add-ons available</div>';
      }
    })
    .catch(error => {
      console.error('Error loading collection products via GraphQL:', error);
      // Show error state
      productsContainer.innerHTML = '<div class="mobile-extras-error">Failed to load add-ons. Please try again.</div>';
    });
  }

  // Load add-on products for mobile extras drawer (legacy function)
  function loadMobileExtrasProducts() {
    const productsContainer = document.getElementById('mobile-extras-products');
    if (!productsContainer) return;
    
    // Get addon products from the same source as addon-drawer
    const addonDrawer = document.getElementById('addon-drawer');
    if (!addonDrawer) {
      // Show empty state if addon-drawer not found
      productsContainer.innerHTML = '<div class="mobile-extras-empty">No add-ons available</div>';
      return;
    }
    
    // Get addon products from addon-drawer
    const addonProductCards = addonDrawer.querySelectorAll('.addon-product-card');
    
    productsContainer.innerHTML = '';
    
    if (addonProductCards.length === 0) {
      productsContainer.innerHTML = '<div class="mobile-extras-empty">No add-ons available</div>';
      return;
    }
    
    addonProductCards.forEach(card => {
      const productData = extractAddonProductData(card);
      if (productData) {
        const productCard = createMobileExtrasOptionCard(productData);
        productsContainer.appendChild(productCard);
      }
    });
  }

  // Extract addon product data from addon-drawer card
  function extractAddonProductData(card) {
    const productId = card.dataset.addonProductId;
    if (!productId) return null;
    
    const title = card.querySelector('.addon-product-card__title')?.textContent?.trim() || '';
    const variantSelect = card.querySelector('[data-addon-variant-select]');
    const variantId = variantSelect?.value || '';
    const price = parseInt(variantSelect?.dataset.price) || 0;
    const image = card.querySelector('.addon-product-card__image img')?.src || '';
    
    return {
      id: productId,
      title: title,
      price: price,
      image: image,
      variantId: variantId
    };
  }


  // Create mobile extras option card
  function createMobileExtrasOptionCard(option) {
    const optionCard = document.createElement('div');
    optionCard.className = 'mobile-extras-option-card';
    optionCard.setAttribute('data-mobile-extras-option-id', option.id);
    
    // Determine button text and class based on price
    const buttonText = option.price > 0 ? `Add ${formatMoney(option.price)}` : 'Select Upgrade';
    const buttonClass = 'mobile-extras-option-card__button--add';
    
    optionCard.innerHTML = `
      <div class="mobile-extras-option-card__image">
        <img src="${option.image}" alt="${option.title}" loading="lazy" width="100" height="100">
      </div>
      <div class="mobile-extras-option-card__title">${option.title}</div>
      <button type="button" class="mobile-extras-option-card__button ${buttonClass}" data-mobile-extras-toggle-button>
        <span data-mobile-extras-add-text>${buttonText}</span>
        <span data-mobile-extras-remove-text style="display: none;">Remove</span>
      </button>
    `;
    
    // Store option data
    optionCard._optionData = option;
    
    return optionCard;
  }


  // Toggle mobile extras addon
  function toggleMobileExtrasAddon(button) {
    const optionCard = button.closest('.mobile-extras-option-card');
    const optionData = optionCard._optionData;
    const variantId = optionData.variantId;
    
    if (mobileExtrasSelectedAddons.has(variantId)) {
      // Remove addon
      mobileExtrasSelectedAddons.delete(variantId);
      optionCard.classList.remove('selected');
      button.classList.remove('mobile-extras-option-card__button--remove');
      button.classList.add('mobile-extras-option-card__button--add');
      const addText = button.querySelector('[data-mobile-extras-add-text]');
      const removeText = button.querySelector('[data-mobile-extras-remove-text]');
      if (addText) addText.style.display = 'inline';
      if (removeText) removeText.style.display = 'none';
    } else {
      // Add addon
      const addonData = {
        productId: optionData.id,
        variantId: variantId,
        productTitle: optionData.title,
        variantTitle: optionData.title,
        price: optionData.price
      };
      
      mobileExtrasSelectedAddons.set(variantId, addonData);
      optionCard.classList.add('selected');
      button.classList.remove('mobile-extras-option-card__button--add');
      button.classList.add('mobile-extras-option-card__button--remove');
      const addText = button.querySelector('[data-mobile-extras-add-text]');
      const removeText = button.querySelector('[data-mobile-extras-remove-text]');
      if (addText) addText.style.display = 'none';
      if (removeText) removeText.style.display = 'inline';
    }
    
    updateMobileExtrasTotal();
    updateMobileExtrasSelectButton();
  }

  // Update mobile extras total (legacy function - no longer needed)
  function updateMobileExtrasTotal() {
    // This function is no longer needed since we removed the summary section
    // But keeping it for compatibility
  }

  // Update mobile extras select button
  function updateMobileExtrasSelectButton() {
    const selectButton = document.getElementById('mobile-extras-select-upgrade');
    if (!selectButton) return;
    
    // Calculate total price of selected add-ons
    let totalPrice = 0;
    mobileExtrasSelectedAddons.forEach(addon => {
      totalPrice += addon.price || 0;
    });
    
    if (totalPrice > 0) {
      selectButton.textContent = `Upgrade ${formatMoney(totalPrice)}`;
      selectButton.disabled = false;
    } else {
      selectButton.textContent = 'Select Upgrade';
      selectButton.disabled = true;
    }
  }

  // Select mobile extras upgrades
  function selectMobileExtrasUpgrades() {
    // Save addons to storage
    saveMobileExtrasToStorage();
    
    // Update extras icon with count
    updateMobileExtrasIcon(mobileExtrasSelectedAddons.size);
    
    // Close drawer
    closeMobileExtrasDrawer();
    
    // Show success message
    if (mobileExtrasSelectedAddons.size > 0) {
      showMobileExtrasSuccessMessage(`Updated: ${mobileExtrasSelectedAddons.size} add-on(s) selected. They will be added to cart when you click "Add to cart".`);
    } else {
      showMobileExtrasSuccessMessage(`Add-ons cleared. No add-ons will be added to cart.`);
    }
  }

  // Save mobile extras to storage
  function saveMobileExtrasToStorage() {
    const addonsArray = Array.from(mobileExtrasSelectedAddons.values());
    const mainProductId = getCurrentProductId();
    
    if (mainProductId) {
      if (addonsArray.length === 0) {
        // Clear storage if no add-ons selected
        localStorage.removeItem(`mobileProductAddons_${mainProductId}`);
      } else {
        const storageData = {
          addons: addonsArray,
          timestamp: Date.now()
        };
        
        localStorage.setItem(`mobileProductAddons_${mainProductId}`, JSON.stringify(storageData));
      }
    }
  }

  // Load saved mobile extras (legacy function - no longer used)
  function loadSavedMobileExtras() {
    // This function is no longer used since we reset add-ons on each popup open
    // But keeping it for compatibility
  }

  // Update mobile extras UI from current selections
  function updateMobileExtrasUIFromStorage() {
    // Update option cards based on current selections
    mobileExtrasSelectedAddons.forEach((addon, variantId) => {
      const optionCard = document.querySelector(`[data-mobile-extras-option-id="${addon.productId}"]`);
      
      if (optionCard) {
        optionCard.classList.add('selected');
        const button = optionCard.querySelector('[data-mobile-extras-toggle-button]');
        if (button) {
          button.classList.remove('mobile-extras-option-card__button--add');
          button.classList.add('mobile-extras-option-card__button--remove');
          const addText = button.querySelector('[data-mobile-extras-add-text]');
          const removeText = button.querySelector('[data-mobile-extras-remove-text]');
          if (addText) addText.style.display = 'none';
          if (removeText) removeText.style.display = 'inline';
        }
      }
    });
    
    // Also ensure unselected cards are properly styled
    document.querySelectorAll('.mobile-extras-option-card').forEach(card => {
      const optionId = card.getAttribute('data-mobile-extras-option-id');
      const isSelected = Array.from(mobileExtrasSelectedAddons.values()).some(addon => addon.productId === optionId);
      
      if (!isSelected) {
        card.classList.remove('selected');
        const button = card.querySelector('[data-mobile-extras-toggle-button]');
        if (button) {
          button.classList.remove('mobile-extras-option-card__button--remove');
          button.classList.add('mobile-extras-option-card__button--add');
          const addText = button.querySelector('[data-mobile-extras-add-text]');
          const removeText = button.querySelector('[data-mobile-extras-remove-text]');
          if (addText) addText.style.display = 'inline';
          if (removeText) removeText.style.display = 'none';
        }
      }
    });
    
    updateMobileExtrasTotal();
    updateMobileExtrasSelectButton();
  }

  // Update mobile extras icon
  function updateMobileExtrasIcon(count) {
    // Find all extras icons in mobile popup and update them
    document.querySelectorAll('.popup-overlay .extras-icon').forEach(icon => {
      if (count > 0) {
        icon.textContent = count;
        icon.style.fontSize = '10px';
        icon.style.fontWeight = 'bold';
      } else {
        icon.textContent = '+';
        icon.style.fontSize = '';
        icon.style.fontWeight = '';
      }
    });
  }

  // Show mobile extras success message
  function showMobileExtrasSuccessMessage(message) {
    // Create success notification
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #28a745;
      color: white;
      padding: 12px 20px;
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 10000;
      font-size: 14px;
      font-weight: 500;
    `;
    notification.textContent = message;
    
    document.body.appendChild(notification);
    
    // Auto remove after 3 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 3000);
  }

  // Get current product ID for mobile popup
  function getCurrentProductId() {
    const popup = document.querySelector('.popup-overlay');
    if (!popup) return null;
    
    const productCard = popup.querySelector('.main-prd-card');
    if (!productCard) return null;
    
    const productHandle = productCard.getAttribute('data-product-handle');
    if (!productHandle) return null;
    
    // For now, use handle as ID. In a real implementation, you'd want to get the actual product ID
    return productHandle;
  }

  // Format money helper
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(cents / 100);
  }

  // Get mobile extras for product
  function getMobileExtrasForProduct(productId) {
    try {
      const storageKey = `mobileProductAddons_${productId}`;
      const stored = localStorage.getItem(storageKey);
      
      if (stored) {
        const productAddons = JSON.parse(stored);
        const addons = productAddons.addons || [];
        return addons;
      }
    } catch (error) {
      // Silent error handling
    }
    return [];
  }

  // Handle mobile extras add to cart
  async function handleMobileExtrasAddToCart(variantId, savedMobileExtras, mainProductId, buttonElement) {
    try {
      // Create a single bundle ID for all items to ensure consistency
      const addonCount = savedMobileExtras ? savedMobileExtras.length : 0;
      const randomString = Math.random().toString(36).substr(2, 9);
      const bundleId = `mobile_bundle_${mainProductId}_${addonCount}addons_${Date.now()}_${randomString}`;
      const cartTimestamp = Date.now().toString();
      const sessionId = getSessionId();
      
      // Create unique identifier to prevent quantity merging
      const uniqueId = Date.now().toString() + Math.random().toString(36).substr(2, 9);
      
      // Prepare cart items with properties
      const cartItems = [
        {
          id: variantId,
          quantity: 1,
          properties: {
            '_is_main_product': 'true',
            '_addon_for': mainProductId,
            '_main_product_id': mainProductId,
            '_cart_timestamp': cartTimestamp,
            '_addon_count': savedMobileExtras ? savedMobileExtras.length : 0,
            '_bundle_id': bundleId,
            '_session_id': sessionId,
            '_unique_id': uniqueId,
            '_is_mobile_popup': 'true'
          }
        }
      ];
      
      // Add mobile extras to cart items with properties
      if (savedMobileExtras && savedMobileExtras.length > 0) {
        savedMobileExtras.forEach((addon, index) => {
          // Create unique ID for each addon
          const addonUniqueId = Date.now().toString() + Math.random().toString(36).substr(2, 9) + '_mobile_addon_' + (index + 1);
          
          cartItems.push({
            id: addon.variantId,
            quantity: 1,
            properties: {
              '_is_addon': 'true',
              '_addon_for': mainProductId,
              '_addon_product_id': addon.productId,
              '_addon_title': addon.productTitle,
              '_addon_variant_id': addon.variantId,
              '_addon_variant_title': addon.variantTitle || '',
              '_addon_price': addon.price || '',
              '_addon_type': addon.type || 'upgrade',
              '_cart_timestamp': cartTimestamp,
              '_bundle_id': bundleId,
              '_session_id': sessionId,
              '_unique_id': addonUniqueId,
              '_addon_index': index + 1,
              '_is_mobile_popup': 'true'
            }
          });
        });
      }
      
      // Add all items to cart in a single request
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ 
          items: cartItems,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });
      
      if (response.ok) {
        const responseData = await response.json();
        
        // Check for errors in response
        if (responseData.status) {
          // Handle error response
          alert('Error adding to cart: ' + responseData.description);
          return;
        }
        
        // Clear mobile extras from storage after successful add to cart
        clearMobileExtrasForProduct(mainProductId);
        
        // Update cart drawer with sections if available
        if (responseData.sections) {
          updateCartDrawerWithSections(responseData.sections);
        } else {
          // Fallback: trigger cart update event
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
        
        // Publish cart update event
        if (window.PUB_SUB_EVENTS && window.publish) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'mobile-popup-extras',
            productVariantId: variantId,
            cartData: responseData,
          });
        }
        
        // Open cart drawer to show all items
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            // Ensure is-empty class is removed before opening
            cartDrawer.classList.remove('is-empty');
            
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              // Fallback: try to trigger the cart drawer by clicking the cart icon
              const cartIcon = document.querySelector('#cart-icon-bubble');
              if (cartIcon) {
                cartIcon.click();
              }
            }
          }
        }, 500);
        
        // Close popup after successful add to cart
        setTimeout(() => {
          closePopup();
        }, 1000);
        
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to add items to cart');
      }
      
    } catch (error) {
      alert('Error adding to cart: ' + error.message);
    } finally {
      // Reset button state
      buttonElement.disabled = false;
      buttonElement.style.opacity = '1';
      
      if (buttonElement.querySelector('span')) {
        buttonElement.querySelector('span').textContent = 'Add to Cart';
      }
    }
  }

  // Clear mobile extras for product
  function clearMobileExtrasForProduct(productId) {
    localStorage.removeItem(`mobileProductAddons_${productId}`);
  }

  // Get session ID (same as product-form.js and addon-drawer.js)
  function getSessionId() {
    let sessionId = sessionStorage.getItem('cart_session_id');
    if (!sessionId) {
      sessionId = 'session_' + Date.now().toString() + '_' + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem('cart_session_id', sessionId);
    }
    return sessionId;
  }

  // Update cart drawer and cart icon bubble with sections (same as addon-drawer.js)
  function updateCartDrawerWithSections(sections) {
    try {
      // Update cart drawer content
      if (sections['cart-drawer']) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          // Parse the cart drawer HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = sections['cart-drawer'];
          
          // Update the entire cart drawer structure, not just the items container
          // This ensures the empty state is properly handled
          const newCartDrawer = tempDiv.querySelector('cart-drawer');
          if (newCartDrawer) {
            // Update the main cart drawer content
            const cartDrawerInner = cartDrawer.querySelector('.drawer__inner');
            const newCartDrawerInner = newCartDrawer.querySelector('.drawer__inner');
            
            if (cartDrawerInner && newCartDrawerInner) {
              cartDrawerInner.innerHTML = newCartDrawerInner.innerHTML;
            }
            
            // Also update the cart drawer items container specifically
            const cartItemsContainer = cartDrawer.querySelector('#CartDrawer-CartItems');
            const newCartItems = newCartDrawer.querySelector('#CartDrawer-CartItems');
            
            if (cartItemsContainer && newCartItems) {
              cartItemsContainer.innerHTML = newCartItems.innerHTML;
            }
            
            // Remove is-empty class from cart drawer to show items
            cartDrawer.classList.remove('is-empty');
          } else {
            // Fallback: just update the items container
            const cartItemsContainer = cartDrawer.querySelector('#CartDrawer-CartItems');
            const newCartItems = tempDiv.querySelector('#CartDrawer-CartItems');
            
            if (cartItemsContainer && newCartItems) {
              cartItemsContainer.innerHTML = newCartItems.innerHTML;
            }
            
            // Remove is-empty class from cart drawer to show items
            cartDrawer.classList.remove('is-empty');
          }
        }
      }
      
      // Update cart icon bubble
      if (sections['cart-icon-bubble']) {
        const cartIconBubble = document.querySelector('#shopify-section-cart-icon-bubble');
        if (cartIconBubble) {
          cartIconBubble.innerHTML = sections['cart-icon-bubble'];
        } else {
          // Fallback: try to find cart-icon-bubble element
          const cartIconBubbleFallback = document.querySelector('cart-icon-bubble');
          if (cartIconBubbleFallback) {
            cartIconBubbleFallback.innerHTML = sections['cart-icon-bubble'];
          }
        }
      }
      
      // Trigger cart update event for other components
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
    } catch (error) {
      // Fallback to regular cart update
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  // Update slider images
  function updateSliderImages(slider, newImages) {
    if (!slider || !newImages || newImages.length === 0) return;
    
    // Clear existing slides
    slider.innerHTML = '';
    
    // Add new slides
    newImages.forEach((image, index) => {
      const slideContainer = document.createElement('div');
      slideContainer.className = 'popup-slide-container';
      
      const img = document.createElement('img');
      img.src = image.src || image;
      img.alt = image.alt || `Image ${index + 1}`;
      img.loading = 'eager';
      img.className = 'popup-slide-img';
      img.onerror = function() {
        this.src = `https://via.placeholder.com/400x300/cccccc/666666?text=Image+${index + 1}`;
      };
      
      slideContainer.appendChild(img);
      slider.appendChild(slideContainer);
    });
    
    // Reset slider to first image
    slider.style.setProperty('--current-image-index', '0');
    
    // Update counter
    const currentIndexSpan = slider.closest('.popup-overlay').querySelector('.popup-current-index');
    const totalCountSpan = slider.closest('.popup-overlay').querySelector('.popup-total-count');
    
    if (currentIndexSpan) currentIndexSpan.textContent = '1';
    if (totalCountSpan) totalCountSpan.textContent = newImages.length;
    
    // Reset slider width based on new number of slides
    slider.style.width = `${newImages.length * 100}%`;
    
    // Re-initialize slider to reset the currentIndex variable
    const popup = slider.closest('.popup-overlay');
    if (popup) {
      // Remove old event listeners by cloning the elements
      const prevBtn = popup.querySelector('[data-prev="true"]');
      const nextBtn = popup.querySelector('[data-next="true"]');
      
      if (prevBtn) {
        const newPrevBtn = prevBtn.cloneNode(true);
        prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
      }
      
      if (nextBtn) {
        const newNextBtn = nextBtn.cloneNode(true);
        nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);
      }
      
      // Re-initialize slider with fresh state
      initSlider(popup);
    }
  }

  // Initialize slider
  function initSlider(popup) {
    const slider = popup.querySelector('[data-slider="true"]');
    const prevBtn = popup.querySelector('[data-prev="true"]');
    const nextBtn = popup.querySelector('[data-next="true"]');
    const currentIndexSpan = popup.querySelector(".popup-current-index");

    // Reset currentIndex to 0 when initializing
    let currentIndex = 0;
    const totalSlides = slider.children.length; // All children are slides now
    
    // Set slider width based on number of slides
    slider.style.width = `${totalSlides * 100}%`;

    function updateSlider() {
      slider.style.setProperty("--current-image-index", currentIndex);
      currentIndexSpan.textContent = currentIndex + 1;

      // Ensure buttons are always enabled since slider loops
      prevBtn.disabled = false;
      nextBtn.disabled = false;
    }

    function nextSlide() {
      if (currentIndex < totalSlides - 1) {
        currentIndex++;
      } else {
        currentIndex = 0; // Loop back to first slide
      }
      updateSlider();
    }

    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
      } else {
        currentIndex = totalSlides - 1; // Loop to last slide
      }
      updateSlider();
    }

    // Event listeners
    nextBtn.addEventListener("click", nextSlide);
    prevBtn.addEventListener("click", prevSlide);

    // Touch/swipe support
    let startX = 0;
    let startY = 0;
    let isDragging = false;

    slider.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true;
    }, { passive: true });

    slider.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      e.preventDefault();
    }, { passive: false });

    slider.addEventListener("touchend", (e) => {
      if (!isDragging) return;
      isDragging = false;

      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;
      const diffX = startX - endX;
      const diffY = startY - endY;

      // Only trigger if horizontal swipe is greater than vertical
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        if (diffX > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    }, { passive: true });

    // Initialize
    updateSlider();
  }

  // Show popup
  function showPopup(productData, originalCard) {
    const popupHTML = createPopupHTML(productData);
    document.body.insertAdjacentHTML("beforeend", popupHTML);

    const popup = document.querySelector(".popup-overlay");
    const popupContent = popup.querySelector(".popup-content");
    
    // Store reference to original card
    popup.originalCard = originalCard;
  

    if (!popup || !popupContent) {
      return;
    }

    // Animate in
    setTimeout(() => {
      popupContent.style.transform = "translateY(0)";
    }, 50);

    // Initialize slider
    initSlider(popup);

    // Initialize swatches
    initSwatches(popup);

    // Initialize add to cart
    initAddToCart(popup);

    // Initialize more info button
    initMoreInfoButton(popup);

    // Initialize mobile extras drawer
    initMobileExtrasDrawer(popup);

    // Add event listeners
    const closeBtn = popup.querySelector(".popup-close");
    closeBtn.addEventListener("click", function(e) {
      e.preventDefault(); // Prevent default link behavior
      closePopup();
    });

    // Close on overlay click
    popup.addEventListener("click", function (e) {
      if (e.target === popup) {
        closePopup();
      }
    });

    // Prevent popup content from closing when clicked
    popupContent.addEventListener("click", function (e) {
      e.stopPropagation();
    });

    // Prevent body scroll
    document.body.style.overflow = "hidden";
  }

  // Close popup
  function closePopup() {
    const popup = document.querySelector(".popup-overlay");
    if (popup) {
      const popupContent = popup.querySelector(".popup-content");
      popupContent.style.transform = "translateY(100%)";

      setTimeout(() => {
        popup.remove();
        document.body.style.overflow = "";
      }, 500);
    }
  }

  // Handle product card clicks
  function handleProductCardClick(e) {
    if (!isMobile()) {
      return;
    }

    const card = e.currentTarget.closest(".main-prd-card");

    const productData = extractProductData(card);
    showPopup(productData, card);
  }

  // Add click listeners to product cards
  function setupProductCardListeners() {
    const productCards = document.querySelectorAll(".main-prd-card:not([data-mobile-popup-initialized])");
    
    productCards.forEach((card, index) => {
      // Mark as initialized to avoid double initialization
      card.setAttribute('data-mobile-popup-initialized', 'true');
      
      const productLink = card.querySelector(".product-link");
      const cardImage = card.querySelector(".main-prd-card-img");
      
      // COMMENTED OUT: Mobile popup functionality - can be enabled later
      // On mobile, product card images now use normal href navigation
      /*
      // Always add click listener to the image area, but check mobile inside
      if (cardImage) {
        cardImage.addEventListener("click", function(e) {
          if (isMobile()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            handleProductCardClick(e);
            return false;
          } else {
          }
        });
      }
      */
      
      if (productLink) {
        // COMMENTED OUT: Mobile popup functionality - can be enabled later
        // On mobile, product links now use normal href navigation
        /*
        // Always add listener, but check mobile inside
        productLink.addEventListener("click", function(e) {
          if (isMobile()) {
            e.preventDefault(); // Prevent default link behavior
            e.stopPropagation();
            e.stopImmediatePropagation(); // Stop all other event listeners
            handleProductCardClick(e);
            return false; // Additional prevention
          } else {
            // On desktop, let the link work normally
          }
        });
        
        // Only modify href on mobile
        if (isMobile()) {
          const hrefValue = productLink.getAttribute('href');
          if (hrefValue) {
            productLink.setAttribute('data-url', hrefValue);
            productLink.removeAttribute('href');
          }
        }
        */
      }
    });
  }
  
  // Setup listeners initially
  setupProductCardListeners();
  
  // Make functions globally available for dynamic content
  window.setupProductCardListeners = setupProductCardListeners;
  window.handleProductCardClick = handleProductCardClick;

  // Handle window resize
  window.addEventListener("resize", function () {
    if (!isMobile()) {
      closePopup();
    }
    // Re-setup listeners on resize to handle mobile/desktop changes
    setupProductCardListeners();
  });
  
  // Expose initSlider globally for use by material-swatch-handler.js
  window.initSlider = initSlider;
});
